import { z } from 'zod';
import { TestSetStatusFilterSchema } from '@/features/stacktrace/test-sets/-constants';
import { TestSetTableColumns } from './-table/type';

/**
 * テストスイート詳細 > テストセットタブ で利用する URL search 定義。
 *
 * `testPlanId` は URL ではなくページコンポーネント側で `ReleaseTest.testSet.testPlanId`
 * を取得して固定値として注入するため、ここでは管理しない。
 */
export const TestSetTableFilterSchema = z.object({
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  sortColumn: z.nativeEnum(TestSetTableColumns).optional(),
  orderDirection: z.enum(['asc', 'desc']).default('desc'),
  status: TestSetStatusFilterSchema.default('ALL')
});